import { SectionHeadline } from '@/components/SectionHeadline';
import { ArticleBox, ArticleBoxProps } from '@/components/boxes';
import { Button } from '@/components/buttons';
import { LinkProps } from '@/components/links';
import React from 'react';
import { mergeClasses } from '@/utils/style';

function Articles({
	articles,
	articlesTarget,
	button,
	title,
	className,
	anchorKey = 'articles.title',
}: {
	articles: ArticleBoxProps[];
	articlesTarget?: LinkProps['target'];
	button?: {
		analyticsParam: string;
		link: LinkProps['to'];
		label: string;
		testId: string;
	};
	title: string | JSX.Element;
	className?: string;
	anchorKey?: string;
}): React.JSX.Element {
	return (
		<div className={mergeClasses('4xl:px-16 bg-blue-100 py-14 lg:py-20 2xl:px-7', className)}>
			<div className="w-full rounded-3xl bg-blue-900 px-4 py-14 xl:py-20">
				<SectionHeadline variant="inverted" anchorKey={anchorKey}>
					{title}
				</SectionHeadline>
				<div className="mx-auto flex max-w-292 flex-col gap-2 py-12 lg:flex-row lg:gap-8 xl:py-16">
					{articles.map((article) => (
						<ArticleBox {...article} key={article.link.toString()} target={articlesTarget} />
					))}
				</div>
				{button && (
					<Button
						to={button.link}
						analyticsParam={button.analyticsParam}
						testId={button.testId}
						variant="primary"
						align="center"
						size="lg"
					>
						{button.label}
					</Button>
				)}
			</div>
		</div>
	);
}

export default Articles;
